export default __webpack_public_path__ + "static/media/the-hijackers-guide-to-digital-activism_dataset.657b0974.xlsx";